import React, { useEffect, useState } from "react";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import { get } from "../../../controlers/global/ConfigRequest";
import {
    USER_PANEL_CLUB,
    USER_PANEL_CLUB_CONTENT_PER_COMPANY,
} from "../../../helperData/ApiAddress";
import ContentModal from "./UserContentModal";
import ProductCard from "./ProductCard";
import { ReactComponent as Logo } from "../../../asset/icons/amazon_logo_wob_lg.svg";
import "./style.scss";

const MEMBERSHIP_LABEL = {
    public: "UserPanel.Participations.Membership.Public",
    org: "UserPanel.Participations.Membership.Org",
    special: "UserPanel.Participations.Membership.Special",
};

function MembershipBadge({ type, t }) {
    const key = MEMBERSHIP_LABEL[type] || MEMBERSHIP_LABEL.public;
    return <span className={`membership-badge membership-badge--${type || "public"}`}>{t(key)}</span>;
}

function ClubMemberships({ clubs, loading, t }) {
    if (loading) {
        return (
            <div className="user-panel-empty">
                <Spinner animation="border" />
            </div>
        );
    }
    if (!clubs?.length) {
        return (
            <div className="user-panel-empty">
                {t("UserPanel.Participations.Clubs.Empty")}
            </div>
        );
    }
    return (
        <div className="club-membership-grid">
            {clubs.map((club) => (
                <div className="club-membership-card" key={club.id}>
                    <div className="club-membership-card__head">
                        <div className="club-membership-card__logo">
                            {club.logo ? (
                                <img src={club.logo} alt="" />
                            ) : (
                                <Logo />
                            )}
                        </div>
                        <div>
                            <strong>{club.name}</strong>
                            <MembershipBadge type={club.membership_type} t={t} />
                        </div>
                    </div>
                    <div className="club-membership-card__stats">
                        <div>
                            <span>{t("Organizational.CustomerClub.Members.Metric.Ideas")}</span>
                            <strong>{club.ideas_count || 0}</strong>
                        </div>
                        <div>
                            <span>{t("UserPanel.Participations.Metric.Referrals")}</span>
                            <strong>{club.referral_opens || 0}</strong>
                        </div>
                        <div>
                            <span>{t("UserPanel.Participations.Metric.Shares")}</span>
                            <strong>{club.successful_shares || 0}</strong>
                        </div>
                        <div>
                            <span>{t("Organizational.CustomerClub.Members.Metric.Coins")}</span>
                            <strong>{club.coins_earned || 0}</strong>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

function ReceivedContent({ clubs, t }) {
    const [selectedCompany, setSelectedCompany] = useState(clubs?.[0]?.company);
    const [contentList, setContentList] = useState(undefined);
    const [contentModalShow, setContentModalShow] = useState(0);

    useEffect(() => {
        if (!selectedCompany && clubs?.length) {
            setSelectedCompany(clubs[0].company);
        }
    }, [clubs, selectedCompany]);

    useEffect(() => {
        if (!selectedCompany) {
            setContentList([]);
            return;
        }
        setContentList(undefined);
        get(USER_PANEL_CLUB_CONTENT_PER_COMPANY.replace(":id", selectedCompany))
            .then((r) => setContentList(r.results || r || []))
            .catch(() => setContentList([]));
    }, [selectedCompany]);

    return (
        <>
            <ContentModal
                show={contentModalShow}
                onHide={() => setContentModalShow(false)}
            />
            <div className="received-content-toolbar">
                <select
                    value={selectedCompany || ""}
                    onChange={(e) => setSelectedCompany(Number(e.target.value) || e.target.value)}
                >
                    {(clubs || []).map((club) => (
                        <option key={club.id} value={club.company}>
                            {club.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="card-container received-content-grid">
                {contentList === undefined && <Spinner animation="border" />}
                {contentList?.length > 0
                    ? contentList.map((content) => (
                          <ProductCard
                              key={content.id}
                              onClick={() => setContentModalShow(content.id)}
                              title={content.name}
                              description={content.description}
                              coin={content.coin}
                              company={content.company?.name || content.company}
                              date={content.created_at}
                              like={content.likes_count}
                              dislike={content.dislikes_count}
                              view={content.views_count}
                              image={content.file}
                          />
                      ))
                    : contentList && (
                          <div className="user-panel-empty">
                              {t("UserPanel.CustomerClub.NothingToShow.Label")}
                          </div>
                      )}
            </div>
        </>
    );
}

export default function UserCustomerClub() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("1");
    const [clubs, setClubs] = useState(undefined);

    useEffect(() => {
        get(USER_PANEL_CLUB)
            .then((r) => setClubs(Array.isArray(r) ? r : []))
            .catch(() => setClubs([]));
    }, []);

    return (
        <div id="user-customer-club" className="main_panel_box user-profile user-participations">
            <MainPanelHeader />
            <div className="user-profile_content main_panel_content">
                <PanelRightContent>
                    <div className="tab-section">
                        <Tabs
                            activeKey={activeTab}
                            transition={false}
                            className="panel_tab"
                            onSelect={(key) => setActiveTab(key)}
                        >
                            <Tab
                                eventKey="1"
                                className="panel_tab_item"
                                title={t("UserPanel.Participations.Tab.Clubs")}
                            >
                                <ClubMemberships
                                    clubs={clubs}
                                    loading={clubs === undefined}
                                    t={t}
                                />
                            </Tab>
                            <Tab
                                eventKey="2"
                                className="panel_tab_item"
                                title={t("UserPanel.Participations.Tab.Received")}
                            >
                                <ReceivedContent clubs={clubs || []} t={t} />
                            </Tab>
                        </Tabs>
                    </div>
                </PanelRightContent>
            </div>
        </div>
    );
}
